import React from "react";
import { motion } from "framer-motion";

// Scroll-triggered entrance reveal used across homepage sections.
export const Reveal = ({ children, delay = 0, y = 28, className = "", testid }) => (
  <motion.div
    data-testid={testid}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Staggered container + item for lists / word-by-word headlines.
export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09, delayChildren: 0.1 } },
};

export const rise = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export default Reveal;
